module.exports = __webpack_public_path__ + "static/media/042-Sunnyside Pavillion.2fc23509.jpg";